import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/imgs/ic_folder.png';

const _withScopeId = n => (_pushScopeId("data-v-a9fb75c4"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "search-files-select-warp"
};
const _hoisted_2 = {
  class: "tags-main"
};
const _hoisted_3 = ["onClick"];

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));

const _hoisted_5 = [_hoisted_4];
const _hoisted_6 = {
  class: "file-dialog"
};
const _hoisted_7 = {
  key: 0,
  class: "batch-btn"
};
const _hoisted_8 = {
  class: "mg-r--10"
};
const _hoisted_9 = {
  class: "tree-file-lists"
};
const _hoisted_10 = ["onClick"];
import { reactive, ref } from 'vue';
import { getTextWidth } from '@/utils';
import { Close } from '@element-plus/icons-vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'searchFilesSelect',
  props: {
    filePath: {
      type: String,
      default: ''
    },
    clearable: {
      type: Boolean,
      default: false
    },
    // 打开文件列表前是否需要校验
    beforeShowDialogValid: {
      type: Boolean,
      default: false
    },
    showBatchSwitch: {
      type: Boolean,
      default: true
    },
    canSelectFolder: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:filePath', 'on-confirm', 'show-dialog', 'load-node'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const treeProps = {
      label: 'name',
      children: 'zones',
      isLeaf: 'leaf'
    };
    const isBatch = ref(false);
    const treeFilesRef = ref();
    const dialogConfig = reactive({
      visible: false,
      loading: false,
      config: {
        title: '文件列表',
        destroyOnClose: true // isShowConfirm: false

      },
      confirm: done => {
        console.log(nodeItem.value);

        if (nodeItem.value) {
          //console.log('更新filePath', splitFilePath(nodeItem.value, nodeItem.value.data.name))
          emit('update:filePath', splitFilePath(nodeItem.value));
          dialogConfig.visible = false;
          done();
          emit('on-confirm', nodeItem.value);
        } else {
          emit('update:filePath', '/');
          dialogConfig.visible = false;
          done();
          emit('on-confirm', nodeItem.value);
        }
      }
    }); // const filePath = ref('');

    const splitFilePath = node => {
      const parts = [];
      let current = node;

      while (current) {
        parts.unshift(current.data.name);
        current = current.parent;
      }

      return parts.join('');
    };

    const treeFileList = ref([{
      name: 'vod/souths'
    }]);

    const loadNode = (node, resolve) => {
      console.log(123, node);
      emit('load-node', node, resolve);
      return;

      if (props.showBatchSwitch) {
        if (node.level === 0) {
          return resolve([{
            id: 1,
            name: 'vod/souths',
            type: 'dir'
          }]);
        }

        if (node.level == 1) {
          setTimeout(() => {
            const data = [{
              id: 2,
              name: '反方向的钟.mp4',
              leaf: true,
              type: '.mp4'
            }, {
              id: 3,
              name: '/movie',
              type: 'dir'
            }];
            resolve(data);
          }, 500);
        }

        if (node.data.id == 3) {
          setTimeout(() => {
            const data = [{
              id: 4,
              name: '速度与激情10.mp4',
              leaf: true,
              type: '.mp4'
            }, {
              id: 5,
              name: '长空之王.mp4',
              leaf: true,
              type: '.mp4'
            }];
            resolve(data);
          }, 500);
        }
      } else {
        if (node.level === 0) {
          return resolve([{
            id: 1,
            name: 'vod/souths',
            type: 'dir'
          }]);
        }

        if (node.level == 1) {
          setTimeout(() => {
            const data = [{
              id: 2,
              name: '/EN',
              leaf: true,
              type: 'dir'
            }, {
              id: 3,
              name: '/ES',
              type: 'dir'
            }];
            resolve(data);
          }, 500);
        }

        if (node.data.id == 3) {
          setTimeout(() => {
            const data = [{
              id: 4,
              name: '/Movies',
              leaf: true,
              type: 'dir'
            }, {
              id: 5,
              name: '/Series',
              leaf: true,
              type: 'dir'
            }];
            resolve(data);
          }, 500);
        }
      }
    };

    const nodeTarget = ref();
    const nodeItem = ref();

    const nodeClick = (node, data, $event) => {
      console.log(node, data, $event); // console.log(treeFileList.value);
      // console.log(treeFilesRef.value);
      //if (node.data.disabled) return;

      if (isBatch.value || props.canSelectFolder) {
        if (nodeTarget.value) {
          if (nodeTarget.value.style.backgroundImage && nodeItem.value.data.id == node.data.id) {
            nodeTarget.value.style.backgroundImage = '';
            nodeTarget.value = null;
            nodeItem.value = null;
          } else {
            nodeTarget.value.style.backgroundImage = '';
            nodeTarget.value = $event.target;
            nodeItem.value = node;
            $event.target.style.backgroundImage = 'linear-gradient(to right, #d2e9ff, #a6cff5)';
          }
        } else {
          nodeItem.value = node;
          nodeTarget.value = $event.target;
          $event.target.style.backgroundImage = 'linear-gradient(to right, #d2e9ff, #a6cff5)';
        }
      } else {
        if (node.data.type == 'dir') {
          return;
        } else {
          if (nodeTarget.value) {
            if (nodeTarget.value.style.backgroundImage && nodeItem.value.data.id == node.data.id) {
              nodeTarget.value.style.backgroundImage = '';
              nodeTarget.value = null;
              nodeItem.value = null;
            } else {
              nodeTarget.value.style.backgroundImage = '';
              nodeTarget.value = $event.target;
              nodeItem.value = node;
              $event.target.style.backgroundImage = 'linear-gradient(to right, #d2e9ff, #a6cff5)';
            }
          } else {
            nodeItem.value = node;
            nodeTarget.value = $event.target;
            $event.target.style.backgroundImage = 'linear-gradient(to right, #d2e9ff, #a6cff5)';
          }
        }
      }

      console.log('nodeItem', nodeItem.value);
    }; // 批量处理switch滑块change事件


    const switchChange = val => {
      console.log(val);

      if (!val) {
        if (nodeItem.value && nodeItem.value.data.type == 'dir') {
          nodeTarget.value.style.backgroundImage = '';
          nodeTarget.value = null;
          nodeItem.value = null;
        }
      }
    };

    const showDialog = () => {
      if (props.beforeShowDialogValid) {
        emit('show-dialog', () => {
          dialogConfig.visible = true;
        });
      } else {
        dialogConfig.visible = true;
      }
    }; //  内容超出时显示提示


    const tipDisabled = ref(false);

    const clearFilePath = () => {
      emit('update:filePath', '');
    };

    const showTextTip = e => {
      const target = e.target;
      const width = getTextWidth(target.innerText, {
        fontSize: '14px'
      });
      tipDisabled.value = target.offsetWidth < width;
    };

    watch(() => dialogConfig.visible, val => {
      if (val) {
        isBatch.value = false;
        nodeTarget.value = null;
        nodeItem.value = null;
      }
    });
    return (_ctx, _cache) => {
      const _component_MPopper = _resolveComponent("MPopper");

      const _component_el_icon = _resolveComponent("el-icon");

      const _component_el_switch = _resolveComponent("el-switch");

      const _component_el_tree = _resolveComponent("el-tree");

      const _component_m_dialog = _resolveComponent("m-dialog");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_MPopper, {
        disabled: tipDisabled.value,
        placement: "top",
        trigger: "hover",
        content: __props.filePath
      }, {
        reference: _withCtx(() => [_createElementVNode("span", {
          onMouseover: showTextTip,
          class: "pointer file-name"
        }, _toDisplayString(__props.filePath), 33)]),
        _: 1
      }, 8, ["disabled", "content"]), props.clearable && __props.filePath ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "delete-btn pointer",
        onClick: _withModifiers(clearFilePath, ["stop"])
      }, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_unref(Close))]),
        _: 1
      })], 8, _hoisted_3)) : _createCommentVNode("", true), _createElementVNode("div", {
        class: "ic-folder-warp pointer",
        onClick: showDialog
      }, _hoisted_5)]), _createVNode(_component_m_dialog, {
        autoLoading: "",
        modelValue: dialogConfig.visible,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => dialogConfig.visible = $event),
        "dialog-config": dialogConfig.config,
        nativeConfig: {
          width: '50%',
          closeOnClickModal: false
        },
        onOnConfirm: dialogConfig.confirm
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [__props.showBatchSwitch ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('批量处理')), 1), _createVNode(_component_el_switch, {
          modelValue: isBatch.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => isBatch.value = $event),
          onChange: switchChange
        }, null, 8, ["modelValue"])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_9, [_createVNode(_component_el_tree, {
          ref_key: "treeFilesRef",
          ref: treeFilesRef,
          props: treeProps,
          load: loadNode,
          lazy: "",
          "expand-on-click-node": false
        }, {
          default: _withCtx(({
            node,
            data
          }) => [_createVNode(_component_MPopper, {
            disabled: tipDisabled.value,
            placement: "top",
            trigger: "hover",
            content: node.label
          }, {
            reference: _withCtx(() => [_createElementVNode("span", {
              onMouseover: showTextTip,
              class: "item-label",
              onClick: $event => nodeClick(node, data, $event)
            }, _toDisplayString(node.label), 41, _hoisted_10)]),
            _: 2
          }, 1032, ["disabled", "content"])]),
          _: 1
        }, 512)])])]),
        _: 1
      }, 8, ["modelValue", "dialog-config", "onOnConfirm"])]);
    };
  }

});